import React, { useState } from 'react'
import FilterSPAL from '../components/FilterSPAL.jsx'
import WaterLevel from '../components/Chart/WaterLevel.jsx';

const SPAL = ({ onDataToleransi }) => {
    const [data, setData] = useState([]);
    return (
        <div className="flex flex-col items-center justify-center w-full rounded gap-4 bg-white p-4">
            {/* <h2 className="text-2xl">HISTORY BY ACTIVITY</h2> */}

            <FilterSPAL onData={(values) => setData(values)} onDataToleransi={onDataToleransi} />

            <div className="flex flex-col lg:flex-row justify-evenly items-center gap-6 w-full">
                <WaterLevel dataSource={data.BBM_IN} title="Filling" />
                <WaterLevel dataSource={data.BBM_OUT} title="Consumption" />
            </div>
        </div>
    )
}

export default SPAL